import React, { useEffect, useMemo, useState, useCallback } from "react";
import { Modal } from "react-bootstrap";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import AddWorkingHrs from "./AddWorkingHrs";
import {
  getAllMonths,
  getAllYears,
  getDateOnly,
  getMonthName,
  getTotalHours,
  sanitizeEvent,
  toLocalDate,
} from "../../Services/appService";
import { getCurrentUser } from "../../app/store/auth";
import { useDispatch } from "react-redux";
import {
  useLoadCandidateAppsQuery,
  useLoadAppRuningTasksQuery,
  useUploadAppDocumentsMutation,
} from "../../app/store/candidateApiSlice";
import { useAddNewTmLogMutation } from "../../app/store/timeLogApiSlice";
import { appDocumentUploaded } from "../../app/store/documents";
import { getAlert, getConfirmAlert } from "../../Services/appAlerts";
import { uploadFileToBlob } from "../../Services/blobUploadService";

const ADD_TIME_LOG_STYLES = {
  modalContent: {
    overflow: "hidden",
    border: "1px solid rgba(226, 232, 240, 1)",
    boxShadow: "0 24px 60px rgba(15, 23, 42, 0.16)"
  },
  modalDialog: {
    maxWidth: "1120px"
  },
  modalHeader: {
    padding: "18px 22px",
    borderBottom: "1px solid rgba(226, 232, 240, 0.9)",
    background: "#ffffff",
      borderBottom: "1px solid #e2e8f0",
  },
  headerContent: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "16px",
    paddingRight: "0"
  },
  titleWrap: {
    display: "flex",
    alignItems: "center",
    gap: "14px"
  },
  headerIcon: {
    width: "46px",
    height: "46px",
    borderRadius: "0px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#f1f5f9",
      borderBottom: "1px solid #e2e8f0",
    color: "#0f172a",
    fontSize: "21px",
    boxShadow: "none"
  },
  eyebrow: {
    fontSize: "11px",
    fontWeight: 600,
    letterSpacing: "0.12em",
    textTransform: "uppercase",
    color: "#4f46e5",
    marginBottom: "4px"
  },
  title: {
    fontSize: "22px",
    fontWeight: 600,
    color: "#0f172a",
    lineHeight: 1.1,
    margin: 0
  },
  subtitle: {
    fontSize: "13px",
    lineHeight: 1.5,
    color: "#666666",
    margin: 0,
    fontWeight: "normal"
  },
  headerActions: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    flexShrink: 0
  },
  closeButton: {
    width: "38px",
    height: "38px",
    borderRadius: "0px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    color: "#64748b",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
    fontWeight: 600,
    boxShadow: "0 2px 6px rgba(15, 23, 42, 0.04)",
    cursor: "pointer",
    transition: "all 0.2s ease",
    flexShrink: 0
  },
  modalBody: {
    padding: "20px 22px",
    background: "#ffffff",
      borderBottom: "1px solid #e2e8f0",
  },
  helperCard: {
    borderRadius: "0px",
    padding: "16px",
    background: "#ffffff",
      borderBottom: "1px solid #e2e8f0",
    border: "1px solid rgba(191, 219, 254, 0.9)",
    marginBottom: "16px"
  },
  helperTitle: {
    fontSize: "14px",
    fontWeight: 600,
    color: "#0f172a",
    marginBottom: "8px"
  },
  helperText: {
    fontSize: "12px",
    lineHeight: 1.7,
    color: "#64748b",
    margin: 0
  },
  sectionCard: {
    borderRadius: "0px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    boxShadow: "0 12px 26px rgba(15, 23, 42, 0.05)",
    padding: "18px"
  },
  sectionTitle: {
    fontSize: "14px",
    fontWeight: 600,
    color: "#0f172a",
    marginBottom: "6px"
  },
  sectionSubtitle: {
    fontSize: "12px",
    color: "#64748b",
    marginBottom: "14px",
    lineHeight: 1.6
  },
  statsRow: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))",
    gap: "12px",
    marginBottom: "16px"
  },
  statCard: {
    borderRadius: "0px",
    padding: "14px 16px",
    background: "#ffffff",
    border: "1px solid rgba(191, 219, 254, 0.9)",
    boxShadow: "0 10px 26px rgba(37, 99, 235, 0.06)"
  },
  statLabel: {
    fontSize: "11px",
    fontWeight: 600,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: "#64748b",
    marginBottom: "6px"
  },
  statValue: {
    fontSize: "20px",
    fontWeight: 600,
    color: "#0f172a",
    lineHeight: 1.1
  },
  radioWrap: {
    display: "flex",
    alignItems: "center",
    gap: "20px",
    flexWrap: "wrap",
    marginBottom: "10px"
  },
  modeToggleWrap: {
    display: "flex",
    alignItems: "center",
    gap: "20px",
    flexWrap: "wrap",
    marginTop: "4px",
    marginBottom: "6px"
  },
  calendarWrap: {
    height: "auto",
    borderRadius: "0px",
    border: "1px solid #e2e8f0",
    overflow: "hidden",
    background: "#f8fafc",
    padding: "20px"
  },
  calendarShell: {
    borderRadius: "0px",
    border: "none",
    background: "transparent",
    boxShadow: "none",
    padding: 0
  },
  calendarControlCard: {
    borderRadius: "0px",
    border: "1px solid rgba(191, 219, 254, 0.9)",
    background: "#ffffff",
      borderBottom: "1px solid #e2e8f0",
    boxShadow: "0 12px 28px rgba(37, 99, 235, 0.08)",
    padding: "16px 18px",
    marginBottom: "16px"
  },
  calendarTopRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap",
    marginBottom: "12px"
  },
  calendarHeadingWrap: {
    display: "flex",
    alignItems: "center",
    gap: "12px"
  },
  calendarBadge: {
    width: "40px",
    height: "40px",
    borderRadius: "0px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#ffffff",
      borderBottom: "1px solid #e2e8f0",
    color: "#4338ca",
    border: "1px solid rgba(191, 219, 254, 1)",
    boxShadow: "inset 0 1px 0 rgba(255,255,255,0.6)"
  },
  calendarHeadingTitle: {
    fontSize: "14px",
    fontWeight: 600,
    color: "#0f172a",
    marginBottom: "2px"
  },
  calendarHeadingText: {
    fontSize: "12px",
    color: "#64748b",
    lineHeight: 1.6
  },
  calendarHint: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    padding: "8px 12px",
    borderRadius: "0px",
    border: "1px solid rgba(191, 219, 254, 1)",
    background: "#eff6ff",
    color: "#1d4ed8",
    fontSize: "12px",
    fontWeight: 600
  },
  calendarControlsWrap: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "10px",
    flexWrap: "wrap",
    marginLeft: "auto"
  },
  selectWrapper: {
    position: "relative",
    minWidth: "128px"
  },
  selectIcon: {
    position: "absolute",
    left: "12px",
    top: "50%",
    transform: "translateY(-50%)",
    color: "#0f172a",
    fontSize: "13px",
    pointerEvents: "none"
  },
  compactSelect: {
    minHeight: "40px",
    borderRadius: "0px",
    border: "1px solid rgba(191, 219, 254, 1)",
    background: "#ffffff",
    color: "#0f172a",
    fontSize: "12px",
    fontWeight: 600,
    padding: "8px 32px 8px 34px",
    boxShadow: "0 2px 6px rgba(37, 99, 235, 0.06)",
    appearance: "none"
  },
  hoursCardCompact: {
    minHeight: "40px",
    display: "inline-flex",
    alignItems: "center",
    gap: "9px",
    borderRadius: "0px",
    border: "1px solid rgba(191, 219, 254, 1)",
    background: "#ffffff",
      borderBottom: "1px solid #e2e8f0",
    color: "#1d4ed8",
    padding: "8px 14px",
    boxShadow: "0 2px 6px rgba(37, 99, 235, 0.08)",
    whiteSpace: "nowrap"
  },
  hoursLabel: {
    fontSize: "11px",
    fontWeight: 600,
    letterSpacing: "0.05em",
    textTransform: "uppercase"
  },
  hoursValue: {
    fontSize: "14px",
    fontWeight: 600,
    color: "#1e40af"
  },
  toggleCard: {
    marginTop: "16px",
    borderRadius: "0px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    boxShadow: "0 12px 26px rgba(15, 23, 42, 0.05)",
    padding: "16px"
  },
  switchLabel: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    margin: 0,
    color: "#0f172a",
    fontSize: "13px",
    fontWeight: 600,
    cursor: "pointer"
  },
  switchInput: {
    width: "18px",
    height: "18px",
    accentColor: "#2563eb"
  },
  divider: {
    borderTop: "1px solid rgba(226, 232, 240, 1)",
    margin: "18px 0"
  },
  noteBanner: {
    marginTop: "16px",
    padding: "12px 14px",
    borderRadius: "0px",
    background: "#fffbeb",
    border: "1px solid rgba(253, 230, 138, 1)",
    fontSize: "12px",
    lineHeight: 1.6,
    color: "#92400e",
    fontWeight: 600
  },
  modalFooter: {
    padding: "16px 22px 20px 22px",
    borderTop: "1px solid rgba(226, 232, 240, 0.9)",
    background: "#ffffff"
  },
  footerActions: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    gap: "10px",
    flexWrap: "wrap"
  },
  subtleButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "0px",
    border: "1px solid #cbd5e1",
    background: "#ffffff",
    color: "#334155",
    padding: "9px 18px",
    fontSize: "13px",
    fontWeight: 600,
    boxShadow: "0 2px 6px rgba(15, 23, 42, 0.04)",
    cursor: "pointer",
    transition: "all 0.2s ease"
  },
  primaryButton: {
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    borderRadius: "0px",
    border: "1px solid #2563eb",
    background: "#2563eb",
    color: "#ffffff",
    padding: "9px 18px",
    fontSize: "13px",
    fontWeight: 600,
    boxShadow: "0 2px 6px rgba(37, 99, 235, 0.2)",
    cursor: "pointer",
    transition: "all 0.2s ease"
  },
  fieldLabel: {
    fontSize: "11px",
    fontWeight: 600,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    color: "#64748b",
    marginBottom: "8px"
  },
  uploadGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: "12px"
  },
  uploadCard: {
    borderRadius: "0px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
      borderBottom: "1px solid #e2e8f0",
    padding: "14px"
  },
  uploadTitle: {
    fontSize: "13px",
    fontWeight: 600,
    color: "#0f172a",
    marginBottom: "4px"
  },
  uploadHint: {
    fontSize: "12px",
    color: "#64748b",
    marginBottom: "10px",
    lineHeight: 1.5
  },
  inputShell: {
    borderRadius: "0px",
    border: "1px solid rgba(226, 232, 240, 1)",
    background: "#ffffff",
    boxShadow: "inset 0 1px 2px rgba(15, 23, 42, 0.03)"
  }
};

const AddNewTimeLog = (props) => {
  const {
    showHide: tmShowHide,
    handleShowHide,
    popupMode = "calendar",
    viewType,
    selectedObj,
    allTimeLogs,
    candidateObj,
    timeLogInvoices,
    projectStartDate,
  } = props;

  const localizer = momentLocalizer(moment);
  const isDocumentMode = popupMode === "documents";
  const isCalendarMode = !isDocumentMode;

  const years = getAllYears();
  const months = getAllMonths();

  const [selectedDate, setSelectedDate] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");
  const [allEvents, setAllEvents] = useState([]);
  const [docType, setDocType] = useState("monthly");
  const [monthlyHrs, setMonthlyHrs] = useState("");
  const [chkMonthlyHrs, setChkMonthlyHrs] = useState("");
  const [monthlyDays, setMonthlyDays] = useState("");
  const [documents, setDocuments] = useState([]);
  const [wrkHrShowHide, setWrkHrShowHide] = useState(false);
  const [dtObj, setDtObj] = useState(null);
  const [currentWfTask, setCurrentWfTask] = useState(null);
  const [saveBtnProccess, setSaveBtnProccess] = useState(false);
  const [prjStartYear, setPrjStartYear] = useState(0);
  const [prjStartMonth, setPrjStartMonth] = useState(0);
  const [prjStartMonthDay, setPrjStartMonthDay] = useState(0);

  const currentUser = getCurrentUser();
  let usrId = currentUser?.id;
  if (currentUser?.linkUser) usrId = currentUser.linkUser;

  const { data: candidateAppsSelector = [] } = useLoadCandidateAppsQuery(usrId, { skip: !usrId });

  const mainWorkflow = candidateAppsSelector.filter(x => x.workflowType === 1);
  const currentWorkflow = mainWorkflow[0] || null;

  const { data: appTasksSelector = [] } = useLoadAppRuningTasksQuery(
    { wfId: currentWorkflow?.oldWorkflowId, userId: usrId },
    { skip: !currentWorkflow?.oldWorkflowId || !usrId }
  );

  const dispatch = useDispatch();
  const [addNewTmLogMut] = useAddNewTmLogMutation();
  const [uploadAppDocumentsMut] = useUploadAppDocumentsMutation();

  useEffect(() => {
    if (!tmShowHide) {
      //setAllEvents([]);
      setDocuments([]);
    }
  }, [tmShowHide]);

  useEffect(() => {
    if (appTasksSelector.length > 0) {
      const filterTasks = appTasksSelector.filter(
        (x) => x.wiid > 0 && x.wfPhase === "Approved"
      );
      let firstAppTasks = [];
      if (filterTasks.length > 0) {
        firstAppTasks = filterTasks[filterTasks.length - 1];
        setCurrentWfTask(firstAppTasks);
      }
    }
  }, [appTasksSelector]);

  useEffect(() => {
    if (allTimeLogs.length > 0) {
      const events = [];
      allTimeLogs.forEach((t) => {
        if (!t.workingHrs) return;

        const wt = JSON.parse(t.workingHrs);

        wt.forEach((w) => {
          if (w.type === "m") return;
          const dt = toLocalDate(w.start);
          events.push({
            start: dt,
            end: dt,
            title: w.title,
          });
        });

      });
      setAllEvents(events);
      setDocuments([]);
    }
  }, [allTimeLogs, tmShowHide]);

  useEffect(() => {
    if (selectedObj) {
      setSelectedYear(selectedObj.year);
      setSelectedMonth(selectedObj.month);
      setDocType(selectedObj.docUploadType);
      setDocuments([]);
      const dt = new Date(selectedObj.year, selectedObj.month - 1, 1);
      setSelectedDate(dt);
      if (selectedObj.workingHrs) {
        // console.log(selectedObj, "selectedObj")
        try {
          const hrsArray = JSON.parse(selectedObj.workingHrs);
          if (hrsArray.length > 0) {
            const { title, days, type } = hrsArray[0];
            if (type) {
              if (title || days) {
                setChkMonthlyHrs("monthly");
                setMonthlyHrs(title);
                setMonthlyDays(days);
              }
            }
          }
        } catch (err) {
          console.error("Failed to parse workingHrs:", err);
        }
      }
    } else {
      const dt = new Date();
      const year = dt.getFullYear();
      const month = dt.getMonth();
      setSelectedYear(year);
      setSelectedMonth(month + 1);
      setSelectedDate(dt);
      setChkMonthlyHrs("");
      setDocType("monthly");
      setMonthlyHrs("");
      setMonthlyDays("");
      setDocuments([]);
    }

    if (projectStartDate) {
      const dur = new Date(projectStartDate);
      setPrjStartYear(dur.getFullYear());
      setPrjStartMonth(dur.getMonth() + 1);
      setPrjStartMonthDay(dur.getDate());
    } else {
      setPrjStartYear(0);
      setPrjStartMonth(0);
    }
  }, [selectedObj, projectStartDate]);

  const getSelectedTimeLog = useCallback(() => {
    if (!selectedYear || !selectedMonth) return null;
    const selectedTimeLog = allTimeLogs.find(
      (log) =>
        log.year === parseInt(selectedYear) && log.month === parseInt(selectedMonth)
    );

    if (selectedTimeLog) return selectedTimeLog;

    if (
      parseInt(selectedObj?.year) === parseInt(selectedYear) &&
      parseInt(selectedObj?.month) === parseInt(selectedMonth)
    )
      return selectedObj;

    return null;
  }, [selectedYear, selectedMonth, allTimeLogs, selectedObj]);

  const getTotalHoursByDate = useCallback(() => {
    const selectedTimeLog = getSelectedTimeLog();
    if (!selectedTimeLog?.workingHrs) return "0h 0m";
    return getTotalHours(selectedTimeLog.workingHrs);
  }, [getSelectedTimeLog]);

  const saveTimeLogs = useCallback(async (docId) => {
    const selYear = Number(selectedYear);
    const selMonthNum = Number(selectedMonth);

    // Filter events by selected year/month after normalizing start date.
    const filterEvents = allEvents.filter((e) => {
      const startDateOnly = getDateOnly(e?.start);
      if (!startDateOnly || typeof startDateOnly !== "string") return false;

      const [year, month] = startDateOnly.split("-").map(Number);
      return year === selYear && month === selMonthNum;
    });

    const tmObj = {};

    if (isDocumentMode && selectedObj?.id > 0) {
      tmObj.workingHrs = selectedObj?.workingHrs || null;
    }

    // MONTHLY HOURS MODE
    if (!isDocumentMode && chkMonthlyHrs === "monthly" && Number(monthlyHrs) > 0) {
      const selMonth =
        Number(selectedMonth) < 10
          ? "0" + Number(selectedMonth)
          : selectedMonth;

      const selDays = monthlyDays || 0;
      const formattedMonthlyHrs = monthlyHrs.toString().trim();

      const newEvents = [
        {
          start: `${selectedYear}-${selMonth}-01`,
          end: `${selectedYear}-${selMonth}-02`,
          title: formattedMonthlyHrs,
          type: "m",
          days: selDays,
        },
      ];

      tmObj.workingHrs = JSON.stringify(newEvents);
    }
    // DAILY MODE
    else if (!isDocumentMode) {
      tmObj.workingHrs =
        filterEvents.length > 0 ? JSON.stringify(filterEvents) : null;
    }

    // Metadata
    tmObj.candidateId = candidateObj.performerid;
    tmObj.subcontractorId = candidateObj.validId;
    tmObj.docId = docId;
    tmObj.docUploadType = docType;
    tmObj.year = selYear;
    tmObj.month = selMonthNum;

    if (selectedObj?.id > 0) {
      tmObj.id = selectedObj.id;
    }

    try {
      await addNewTmLogMut(tmObj).unwrap();
      if (selectedObj?.id > 0) getAlert("", "Updated Successfully", "success");
      else getAlert("", "Added Successfully", "success");

      setSaveBtnProccess(false);
      handleShowHide("save");
    } catch (err) {
      setSaveBtnProccess(false);
      console.error("Failed to save time log:", err);
      getAlert("", "Failed to save time log", "error");
    }
  }, [
    selectedYear,
    selectedMonth,
    allEvents,
    isDocumentMode,
    selectedObj,
    chkMonthlyHrs,
    monthlyHrs,
    monthlyDays,
    candidateObj,
    docType,
    addNewTmLogMut,
    handleShowHide,
  ]);

  const saveTmLogs = useCallback(async () => {
    const result = await getConfirmAlert(
      "Warning",
      isDocumentMode
        ? "Are you sure you want to upload the selected time sheet document(s)?"
        : "Are you sure you have entered the correct hours for the week/month?",
      "warning"
    );
    if (result.isConfirmed) {
      setSaveBtnProccess(true);
      if (documents.length > 0) {
        try {
          const frmData = new FormData();
          frmData.append("message", "Time Sheet");
          frmData.append("workflowTask", JSON.stringify(currentWfTask));
          frmData.append("userId", currentUser.id);
          frmData.append("docType", docType + "_time_sheet");
          frmData.append("files", JSON.stringify(documents.map(x => ({ name: x.name, type: x.type, size: x.size }))));

          const response = await uploadAppDocumentsMut(frmData).unwrap();
          const docId = response?.uploadId ?? response;
          const sasUrls = response?.sasUrls;

          if (sasUrls && sasUrls.length > 0) {
            await Promise.all(
              documents.map((file, key) =>
                uploadFileToBlob(
                  file.file,
                  sasUrls[key]?.uploadUrl,
                  (progress) => {
                    console.log(`Upload progress: ${progress}%`);
                  }
                )
              )
            );
            console.log("All files uploaded successfully!");
            dispatch(appDocumentUploaded(null));
          }
          await saveTimeLogs(docId || 0);
        } catch (error) {
          console.error("Upload failed:", error);
          setSaveBtnProccess(false);
          getAlert("", "Failed to upload time sheet documents.", "error");
        }
      } else {
        await saveTimeLogs(0);
      }
    }
  }, [
    isDocumentMode,
    documents,
    currentWfTask,
    currentUser.id,
    docType,
    uploadAppDocumentsMut,
    saveTimeLogs,
    dispatch,
  ]);

  const checkInvoiceStatus = useCallback((selectedTimeLog) => {
    const tmLog = selectedTimeLog[0];
    const invType = "subcontractor";
    const checkApproved = timeLogInvoices.filter(
      (x) =>
        x.timeLogId === tmLog.id &&
        x.invoiceType === invType &&
        x.status === true
    );
    if (checkApproved.length > 0)
      getAlert("", "Invoice already approved", "error");
    else saveTmLogs();
  }, [timeLogInvoices, saveTmLogs]);

  const doSubmit = useCallback((type) => {
    if (isDocumentMode) {
      if (documents.length === 0) {
        getAlert("", "Please upload at least one time sheet document.", "error");
        return;
      }
      saveTmLogs();
      return;
    }

    if (type === "reset") setSelectedYear(null);
    const selectedTimeLog = allTimeLogs.filter(
      (x) =>
        x.year === parseInt(selectedYear) && x.month === parseInt(selectedMonth)
    );
    if (selectedTimeLog.length > 0) checkInvoiceStatus(selectedTimeLog);
    else saveTmLogs();
  }, [isDocumentMode, documents, allTimeLogs, selectedYear, selectedMonth, checkInvoiceStatus, saveTmLogs]);

  const handleSelect = useCallback((wrkHr) => {
    if (!dtObj) return;

    const { start } = dtObj;

    // Always convert selected date into YYYY-MM-DD
    const selectedDate = getDateOnly(start);

    // Clean list (remove any events that have times)
    let updatedEvents = [...allEvents].map((ev) => sanitizeEvent(ev));

    // Find all events on this day
    const sameDayEvents = updatedEvents.filter((x) => x.start === selectedDate);

    if (sameDayEvents.length > 0) {
      // Take first one to update
      const target = sameDayEvents[0];
      const targetIndex = updatedEvents.indexOf(target);

      // Remove duplicates on same date (if any)
      if (sameDayEvents.length > 1) {
        sameDayEvents.slice(1).forEach((dupEv) => {
          const dupIndex = updatedEvents.indexOf(dupEv);
          if (dupIndex !== -1) updatedEvents.splice(dupIndex, 1);
        });
      }

      // Update the selected event
      updatedEvents[targetIndex] = {
        ...updatedEvents[targetIndex],
        title: wrkHr,
      };
    } else {
      // Add new event (date-only)
      updatedEvents.push({
        start: selectedDate,
        end: selectedDate,
        title: wrkHr,
      });
    }

    setAllEvents(updatedEvents);
    setWrkHrShowHide(false);
    setDtObj(null);
  }, [dtObj, allEvents]);

  const handleeEditSelect = useCallback((wrkHr) => {
    if (!dtObj) return;

    // Always sanitize date fields from dtObj
    const targetStart = getDateOnly(dtObj.start);
    const targetEnd = getDateOnly(dtObj.end);
    const targetTitle = dtObj.title;

    // Always sanitize event list to keep everything date-only
    const events = [...allEvents].map((ev) => sanitizeEvent(ev));

    // Find correct event (safe for USA/India timezones)
    const index = events.findIndex((x) => {
      return (
        x.start === targetStart &&
        x.end === targetEnd &&
        x.title === targetTitle
      );
    });

    if (index === -1) return; // No match found

    // Update the found event immutably
    const updatedEvents = [...events];
    updatedEvents[index] = {
      ...updatedEvents[index],
      title: wrkHr,
    };

    setAllEvents(updatedEvents);
  }, [dtObj, allEvents]);

  const handleYearChange = useCallback(({ currentTarget }) => {
    setSelectedYear(currentTarget.value);
    const newDt = new Date(currentTarget.value, selectedMonth - 1, 1);
    setSelectedDate(newDt);
  }, [selectedMonth]);

  const handleMonthChange = useCallback(({ currentTarget }) => {
    if (prjStartYear === selectedYear && currentTarget.value < prjStartMonth) {
      getAlert(
        "",
        `Month should be greater than or equal to ${months.find((x) => x.id === prjStartMonth).name
        }`,
        "error"
      );
      return;
    }
    setSelectedMonth(currentTarget.value);
    const newDt = new Date(selectedYear, currentTarget.value - 1, 1);
    setSelectedDate(newDt);

    setChkMonthlyHrs("");
    setMonthlyHrs("");
    setMonthlyDays("");
    const filteredLogs = allTimeLogs.filter(
      (log) =>
        log.year === parseInt(selectedYear) && log.month === parseInt(currentTarget.value)
    );
    if (filteredLogs.length > 0) {
      const workingHrs = filteredLogs[0].workingHrs;
      const hrsArray = JSON.parse(workingHrs);
      if (hrsArray.length > 0) {
        const { title, days, type } = hrsArray[0];
        if (type) {
          if (title || days) {
            setChkMonthlyHrs("monthly");
            setMonthlyHrs(title);
            setMonthlyDays(days);
          }
        }
      }
    }
  }, [prjStartYear, selectedYear, prjStartMonth, months, allTimeLogs]);

  const handleDateChanged = useCallback((date) => {
    // Extract safe local date (prevents timezone shift)
    const getLocalDateParts = (d) => {
      const dt = new Date(d);
      return {
        year: dt.getFullYear(),
        month: dt.getMonth(), // 0-based
        day: dt.getDate(),
        full: dt,
      };
    };

    const { year, month, full } = getLocalDateParts(date);

    const cyear = new Date().getFullYear();
    const cmonth = new Date().getMonth();

    const findYear = years.filter((x) => x.name === year);

    if (
      (year === cyear && month <= cmonth && findYear.length > 0) ||
      (year < cyear && findYear.length > 0)
    ) {
      setSelectedYear(year);
      setSelectedMonth(month + 1); // convert 0-based → 1-based
      setSelectedDate(full); // safe Date object
    }
  }, [years]);

  const onFileChange = useCallback(async (event) => {
    const docs = [...documents];
    for (let file of event.target.files) {
      var doc = {
        name: file.name,
        type: file.type,
        file: file,
        size: file.size,
      };
      docs.push(doc);
    }
    setDocuments(docs);
  }, [documents]);

  const handleWrkHrShowHide = useCallback((obj) => {
    if (!obj) {
      setWrkHrShowHide(false);
      setDtObj(null);
      return;
    }

    const dt = new Date(obj.start); // Date user clicked
    const now = new Date();

    // Compare only the date (ignore time)
    const currentDate = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate()
    );
    const targetDate = new Date(dt.getFullYear(), dt.getMonth(), dt.getDate());

    // 🔢 Convert all year/month/day values to numbers
    const selectedYearNum = parseInt(selectedYear, 10);
    const selectedMonthNum = parseInt(selectedMonth, 10);
    const prjStartYearNum = parseInt(prjStartYear, 10);
    const prjStartMonthNum = parseInt(prjStartMonth, 10);
    const prjStartMonthDayNum = parseInt(prjStartMonthDay, 10);

    const currentMonth = now.getMonth() + 1;
    const currentYear = now.getFullYear();

    if (dt.getMonth() + 1 !== selectedMonthNum) return;

    const showError = (msg) => getAlert("", msg, "error");
    const selectedDateKey = getDateOnly(obj.start);
    const existingEvent = allEvents.find(
      (event) => getDateOnly(event?.start) === selectedDateKey
    );
    const popupObj = existingEvent
      ? {
        ...existingEvent,
        start: existingEvent.start || obj.start,
        end: existingEvent.end || existingEvent.start || obj.end || obj.start,
        title: existingEvent.title,
      }
      : obj;

    // --- 1️⃣ Block: Before project start ---
    if (
      selectedYearNum < prjStartYearNum ||
      (selectedYearNum === prjStartYearNum &&
        selectedMonthNum < prjStartMonthNum)
    ) {
      return showError(
        "You cannot add working hours for months before the project start date."
      );
    }

    // --- 🆕 Additional Day Check for Project Start Month ---
    if (
      selectedYearNum === prjStartYearNum &&
      selectedMonthNum === prjStartMonthNum
    ) {
      if (dt.getDate() < prjStartMonthDayNum) {
        return showError(
          `You cannot add working hours before the project start date (${prjStartMonthDayNum}/${prjStartMonthNum}/${prjStartYearNum}).`
        );
      }
    }

    // --- 2️⃣ Block: Future months ---
    if (
      selectedYearNum > currentYear ||
      (selectedYearNum === currentYear && selectedMonthNum > currentMonth)
    ) {
      return showError("You cannot add working hours for future months.");
    }

    // --- 3️⃣ Current month handling ---
    if (selectedYearNum === currentYear && selectedMonthNum === currentMonth) {
      if (targetDate > currentDate) {
        return showError("You cannot add working hours for future dates.");
      }

      // ✅ Allow today and past dates in current month
      setDtObj(popupObj);
      setWrkHrShowHide(true);
      return;
    }

    // --- 4️⃣ Past months (after project start, before current month) ---
    if (
      (selectedYearNum > prjStartYearNum ||
        (selectedYearNum === prjStartYearNum &&
          selectedMonthNum >= prjStartMonthNum)) &&
      (selectedYearNum < currentYear ||
        (selectedYearNum === currentYear && selectedMonthNum < currentMonth))
    ) {
      // ✅ Allow all days in past months (after start)
      setDtObj(popupObj);
      setWrkHrShowHide(true);
      return;
    }

    // --- 5️⃣ Fallback ---
    showError("Unable to add working hours for this date.");
  }, [
    selectedYear,
    selectedMonth,
    prjStartYear,
    prjStartMonth,
    prjStartMonthDay,
    allEvents,
  ]);

  const handleChkMonthly = useCallback(({ target }) => {
    if (target.checked) {
      setChkMonthlyHrs("monthly");
    } else {
      setChkMonthlyHrs("");
    }
  }, []);

  const handleReset = useCallback(async () => {
    const result = await getConfirmAlert(
      "Warning",
      "Are you sure you want to Reset the entered hours for the week(s)/month?",
      "warning"
    );

    if (!result.isConfirmed) return;

    // Restore header fields
    if (selectedObj?.id > 0) {
      setSelectedYear(selectedObj.year);
      setSelectedMonth(selectedObj.month);
      setDocType(selectedObj.docUploadType);
      setDocuments([]);

      const dt = new Date(selectedObj.year, selectedObj.month - 1, 1);
      setSelectedDate(dt);
    } else {
      const dt = new Date();
      setSelectedYear(dt.getFullYear());
      setSelectedMonth(dt.getMonth() + 1);
      setSelectedDate(dt);

      setChkMonthlyHrs("");
      setDocType("monthly");
      setMonthlyHrs("");
      setMonthlyDays("");
      setDocuments([]);
    }

    // Build event list safely (with dateUtils)
    const events = [];

    allTimeLogs.forEach((t) => {
      if (!t.workingHrs) return;

      const wt = JSON.parse(t.workingHrs);

      wt.forEach((w) => {
        // Convert any format → YYYY-MM-DD safely
        const cleanEvent = sanitizeEvent({
          start: w.start,
          end: w.start,
          title: w.title,
        });

        events.push(cleanEvent);
      });
    });

    setAllEvents(events);
    getAlert("", "Reset Successfully", "success");
  }, [selectedObj, allTimeLogs]);

  const eventStyleGetter = useCallback((event) => {
    const style = {
      background: "transparent",
      border: "0",
      boxShadow: "none",
      color: "transparent",
      height: 0,
      minHeight: 0,
      opacity: 0,
      padding: 0,
      pointerEvents: "none",
    };
    return {
      style,
    };
  }, []);

  const loggedHoursByDate = useMemo(() => {
    return allEvents.reduce((acc, event) => {
      const dateKey = getDateOnly(event?.start);
      if (dateKey) acc[dateKey] = event?.title;
      return acc;
    }, {});
  }, [allEvents]);

  const isBlockedCalendarDate = useCallback((date) => {
    const calendarDate = new Date(date);
    const today = new Date();
    const targetDate = new Date(
      calendarDate.getFullYear(),
      calendarDate.getMonth(),
      calendarDate.getDate()
    );
    const currentDate = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate()
    );
    const selectedYearNum = parseInt(selectedYear, 10);
    const selectedMonthNum = parseInt(selectedMonth, 10);
    const prjStartYearNum = parseInt(prjStartYear, 10);
    const prjStartMonthNum = parseInt(prjStartMonth, 10);
    const prjStartMonthDayNum = parseInt(prjStartMonthDay, 10);

    if (calendarDate.getMonth() + 1 !== selectedMonthNum) return true;
    if (targetDate > currentDate) return true;
    if (!prjStartYearNum || !prjStartMonthNum) return false;
    if (selectedYearNum < prjStartYearNum) return true;
    if (selectedYearNum === prjStartYearNum && selectedMonthNum < prjStartMonthNum)
      return true;
    if (
      selectedYearNum === prjStartYearNum &&
      selectedMonthNum === prjStartMonthNum &&
      calendarDate.getDate() < prjStartMonthDayNum
    )
      return true;

    return false;
  }, [selectedYear, selectedMonth, prjStartYear, prjStartMonth, prjStartMonthDay]);

  const dayPropGetter = useCallback((date) => {
    const dateKey = getDateOnly(date);
    const classes = ["time-log-day-cell"];

    if (loggedHoursByDate[dateKey]) classes.push("time-log-day-cell--logged");
    if (moment(date).isSame(new Date(), "day")) classes.push("time-log-day-cell--today");
    if (date.getMonth() + 1 !== parseInt(selectedMonth, 10))
      classes.push("time-log-day-cell--outside");
    if (isBlockedCalendarDate(date)) classes.push("time-log-day-cell--blocked");

    return { className: classes.join(" ") };
  }, [loggedHoursByDate, selectedMonth, isBlockedCalendarDate]);

  const CalendarEventCard = useCallback(({ event, onClick }) => (
    <div
      className="time-log-entry-card"
      onClick={onClick}
      onMouseDown={(event) => event.stopPropagation()}
      onPointerDown={(event) => event.stopPropagation()}
      role="button"
      tabIndex={0}
    >
      <div className="time-log-entry-accent" aria-hidden="true"></div>
      <div className="time-log-entry-body">
        <div className="time-log-entry-status">
          <i className="fa fa-clock-o" aria-hidden="true"></i>
          {event?.title || "0"} Hour(s)
        </div>
      </div>
    </div>
  ), []);

  const CalendarDateHeader = useCallback(({ date, label, isOffRange }) => {
    const dateKey = getDateOnly(date);
    const loggedHours = loggedHoursByDate[dateKey];
    const loggedEvent = allEvents.find((event) => getDateOnly(event?.start) === dateKey);
    const isToday = moment(date).isSame(new Date(), "day");
    const isBlocked = isBlockedCalendarDate(date);

    return (
      <div
        className={[
          "time-log-date-header",
          loggedHours ? "time-log-date-header--logged" : "",
          isToday ? "time-log-date-header--today" : "",
          isOffRange ? "time-log-date-header--off-range" : "",
          isBlocked ? "time-log-date-header--blocked" : "",
        ]
          .filter(Boolean)
          .join(" ")}
      >
        <div className="time-log-date-top">
          <span className="time-log-date-number">{label}</span>
        </div>
        {loggedHours && !isOffRange && (
          <CalendarEventCard
            event={{
              title: loggedHours,
              start: date,
            }}
            onClick={(clickEvent) => {
              clickEvent.preventDefault();
              clickEvent.stopPropagation();
              if (isBlocked) return;
              const eventForPopup = {
                ...(loggedEvent || {}),
                start: loggedEvent?.start || date,
                end: loggedEvent?.end || loggedEvent?.start || date,
                title: loggedEvent?.title ?? loggedHours,
              };
              handleWrkHrShowHide(eventForPopup);
            }}
          />
        )}
      </div>
    );
  }, [loggedHoursByDate, allEvents, isBlockedCalendarDate, handleWrkHrShowHide]);

  let filterMonths = months.filter((x) => x.id <= new Date().getMonth() + 1);
  if (selectedYear < new Date().getFullYear()) filterMonths = months;

  return (
    <>
      <Modal
        show={tmShowHide}
        size="xl"
        dialogClassName="add-time-log-modal-dialog"
        contentClassName="add-time-log-modal-content"
        centered
      >
        <style>{`
          .add-time-log-modal-dialog {
            max-width: ${ADD_TIME_LOG_STYLES.modalDialog.maxWidth};
          }
          .add-time-log-modal-content,
          .add-time-log-modal-dialog .modal-content {
            overflow: hidden !important;
            border: ${ADD_TIME_LOG_STYLES.modalContent.border} !important;
            box-shadow: ${ADD_TIME_LOG_STYLES.modalContent.boxShadow} !important;
          }
          .add-time-log-calendar .rbc-calendar {
            background: transparent;
            color: #0f172a;
            font-family: inherit;
          }
          .add-time-log-calendar .rbc-toolbar {
            margin-bottom: 14px;
            gap: 10px;
            flex-wrap: wrap;
          }
          .add-time-log-calendar .rbc-toolbar-label {
            font-size: 18px;
            font-weight: 800;
            color: #0f172a;
          }
          .add-time-log-calendar .rbc-btn-group {
            display: inline-flex;
            gap: 8px;
            align-items: center;
            flex-wrap: wrap;
          }
          .add-time-log-calendar .rbc-btn-group button {
            border-radius: 999px;
            border: 1px solid rgba(191, 219, 254, 1);
            background: #ffffff;
            color: #475569;
            font-size: 12px;
            font-weight: 700;
            padding: 7px 12px;
            box-shadow: 0 6px 16px rgba(15, 23, 42, 0.04);
            margin: 0;
            min-width: 80px;
          }
          .add-time-log-calendar .rbc-btn-group button.rbc-active,
          .add-time-log-calendar .rbc-btn-group button:hover,
          .add-time-log-calendar .rbc-btn-group button:focus {
            background: #eff6ff;
            color: #1d4ed8;
            border-color: rgba(191, 219, 254, 1);
            box-shadow: 0 8px 18px rgba(37, 99, 235, 0.08);
          }
          .add-time-log-calendar .rbc-month-view {
            border-radius: 16px;
            overflow: hidden;
            border: 1px solid rgba(226, 232, 240, 1);
            background: #ffffff;
            box-shadow: inset 0 1px 0 rgba(255,255,255,0.9);
          }
          .add-time-log-calendar .rbc-header {
            border-bottom: 1px solid rgba(226, 232, 240, 1);
            padding: 12px 6px;
            background: linear-gradient(180deg, #f8fbff 0%, #f1f5f9 100%);
            color: #64748b;
            font-size: 11px;
            font-weight: 800;
            letter-spacing: 0.08em;
            text-transform: uppercase;
          }
          .add-time-log-calendar .rbc-month-row + .rbc-month-row {
            border-top: 1px solid rgba(226, 232, 240, 0.8);
          }
          .add-time-log-calendar .rbc-month-row {
            min-height: 78px;
          }
          .add-time-log-calendar .rbc-day-bg + .rbc-day-bg,
          .add-time-log-calendar .rbc-header + .rbc-header {
            border-left: 1px solid rgba(226, 232, 240, 0.7);
          }
          .add-time-log-calendar .rbc-day-bg {
            position: relative;
            background: linear-gradient(180deg, #ffffff 0%, #fbfdff 100%);
            cursor: pointer;
            transition: background 180ms ease, box-shadow 180ms ease;
          }
          .add-time-log-calendar .rbc-day-bg::after {
            content: "";
            position: absolute;
            inset: 8px;
            border-radius: 13px;
            border: 1px solid transparent;
            pointer-events: none;
            transition: border-color 180ms ease, box-shadow 180ms ease, background 180ms ease, transform 180ms ease;
          }
          .add-time-log-calendar .rbc-day-bg:hover::after {
            border-color: rgba(37, 99, 235, 0.34);
            box-shadow: inset 0 0 0 1px rgba(37, 99, 235, 0.1), 0 14px 28px rgba(37, 99, 235, 0.12);
            background: linear-gradient(180deg, rgba(239, 246, 255, 0.9) 0%, rgba(219, 234, 254, 0.45) 100%);
            transform: translateY(-1px);
          }
          .add-time-log-calendar .time-log-day-cell--logged::after {
            border-color: rgba(16, 185, 129, 0.18);
            background: rgba(249, 250, 251, 0.78);
            box-shadow: inset 0 0 0 1px rgba(16, 185, 129, 0.04);
          }
          .add-time-log-calendar .time-log-day-cell--logged:hover::after {
            border-color: rgba(16, 185, 129, 0.4);
            background: linear-gradient(180deg, rgba(236, 253, 245, 0.95) 0%, rgba(209, 250, 229, 0.5) 100%);
            box-shadow: inset 0 0 0 1px rgba(16, 185, 129, 0.12), 0 14px 28px rgba(16, 185, 129, 0.12);
          }
          .add-time-log-calendar .time-log-day-cell--today::after {
            border-color: rgba(37, 99, 235, 0.42);
            background: linear-gradient(180deg, rgba(239, 246, 255, 0.95) 0%, rgba(219, 234, 254, 0.5) 100%);
            box-shadow: inset 0 0 0 1px rgba(37, 99, 235, 0.14), 0 10px 20px rgba(37, 99, 235, 0.08);
          }
          .add-time-log-calendar .time-log-day-cell--today:hover::after {
            border-color: rgba(79, 70, 229, 0.55);
            background: linear-gradient(180deg, rgba(238, 242, 255, 0.98) 0%, rgba(219, 234, 254, 0.68) 100%);
            box-shadow: inset 0 0 0 1px rgba(79, 70, 229, 0.18), 0 16px 30px rgba(37, 99, 235, 0.16);
          }
          .add-time-log-calendar .time-log-day-cell--blocked {
            cursor: not-allowed;
          }
          .add-time-log-calendar .time-log-day-cell--blocked::after {
            background: rgba(248, 250, 252, 0.8);
            border-color: transparent;
            box-shadow: none;
          }
          .add-time-log-calendar .time-log-day-cell--blocked:hover::after {
            background: rgba(248, 250, 252, 0.86);
            border-color: transparent;
            box-shadow: none;
          }
          .add-time-log-calendar .rbc-date-cell {
            padding: 8px;
            text-align: left;
            cursor: pointer;
          }
          .add-time-log-calendar .rbc-date-cell > a {
            color: #475569;
            font-size: 12px;
            font-weight: 700;
          }
          .add-time-log-calendar .time-log-date-header {
            min-height: 62px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            gap: 0;
            position: relative;
            z-index: 3;
            width: 100%;
          }
          .add-time-log-calendar .time-log-date-header::before {
            content: "";
            position: absolute;
            inset: 0;
            border-radius: 13px;
            border: 1px solid transparent;
            pointer-events: none;
            transition: border-color 180ms ease, box-shadow 180ms ease, background 180ms ease, transform 180ms ease;
            z-index: -1;
          }
          .add-time-log-calendar .rbc-date-cell:hover .time-log-date-header::before {
            border-color: rgba(37, 99, 235, 0.34);
            box-shadow: inset 0 0 0 1px rgba(37, 99, 235, 0.1), 0 14px 28px rgba(37, 99, 235, 0.12);
            background: linear-gradient(180deg, rgba(239, 246, 255, 0.9) 0%, rgba(219, 234, 254, 0.45) 100%);
            transform: translateY(-1px);
          }
          .add-time-log-calendar .rbc-date-cell:hover .time-log-date-header--logged::before {
            border-color: rgba(16, 185, 129, 0.4);
            background: linear-gradient(180deg, rgba(236, 253, 245, 0.95) 0%, rgba(209, 250, 229, 0.5) 100%);
            box-shadow: inset 0 0 0 1px rgba(16, 185, 129, 0.12), 0 14px 28px rgba(16, 185, 129, 0.12);
          }
          .add-time-log-calendar .rbc-date-cell:hover .time-log-date-header--today::before {
            border-color: rgba(79, 70, 229, 0.55);
            background: linear-gradient(180deg, rgba(238, 242, 255, 0.98) 0%, rgba(219, 234, 254, 0.68) 100%);
            box-shadow: inset 0 0 0 1px rgba(79, 70, 229, 0.18), 0 16px 30px rgba(37, 99, 235, 0.16);
          }
          .add-time-log-calendar .rbc-date-cell:hover .time-log-date-header--blocked::before,
          .add-time-log-calendar .rbc-date-cell:hover .time-log-date-header--off-range::before {
            background: rgba(248, 250, 252, 0.86);
            border-color: transparent;
            box-shadow: none;
            transform: none;
          }
          .add-time-log-calendar .time-log-date-top {
            width: 100%;
            display: flex;
            justify-content: flex-end;
            position: absolute;
            top: 0;
            right: 0;
          }
          .add-time-log-calendar .time-log-date-number {
            width: 34px;
            height: 34px;
            border-radius: 12px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            color: #475569;
            font-size: 17px;
            font-weight: 800;
            line-height: 1;
            transition: background 160ms ease, color 160ms ease, box-shadow 160ms ease;
          }
          .add-time-log-calendar .time-log-date-header--logged .time-log-date-number {
            color: #047857;
          }
          .add-time-log-calendar .time-log-date-header--today .time-log-date-number {
            color: #2563eb;
          }
          .add-time-log-calendar .time-log-date-header--blocked .time-log-date-number,
          .add-time-log-calendar .time-log-date-header--off-range .time-log-date-number {
            color: #cbd5e1;
          }
          .add-time-log-calendar .rbc-off-range-bg {
            background: #f8fafc;
          }
          .add-time-log-calendar .rbc-off-range .rbc-date-cell > a {
            color: #cbd5e1;
          }
          .add-time-log-calendar .rbc-today {
            background: linear-gradient(180deg, rgba(219, 234, 254, 0.45) 0%, rgba(239, 246, 255, 0.35) 100%);
          }
          .add-time-log-calendar .rbc-row-content {
            z-index: 2;
          }
          .add-time-log-calendar .rbc-row-content,
          .add-time-log-calendar .rbc-row {
            overflow: visible;
          }
          .add-time-log-calendar .rbc-row-segment {
            padding: 0;
          }
          .add-time-log-calendar .rbc-event {
            display: none;
          }
          .add-time-log-calendar .rbc-event:focus {
            outline: none;
          }
          .add-time-log-calendar .rbc-selected {
            background: transparent;
          }
          .add-time-log-calendar .rbc-event-content {
            display: none;
          }
          .add-time-log-calendar .time-log-entry-card {
            width: min(100%, 170px);
            min-height: 34px;
            border-radius: 11px;
            background: #f8fafc;
            box-shadow: 0 7px 15px rgba(15, 23, 42, 0.06);
            border: 1px solid rgba(226, 232, 240, 0.84);
            display: grid;
            grid-template-columns: 4px 1fr;
            column-gap: 8px;
            padding: 5px 7px;
            overflow: hidden;
            align-self: center;
            margin-top: 36px;
            cursor: pointer;
            transition: transform 160ms ease, box-shadow 160ms ease;
          }
          .add-time-log-calendar .time-log-entry-card:focus {
            outline: 2px solid rgba(37, 99, 235, 0.22);
            outline-offset: 2px;
          }
          .add-time-log-calendar .time-log-entry-card:hover {
            transform: translateY(-1px);
            border-color: rgba(16, 185, 129, 0.3);
            box-shadow: 0 14px 26px rgba(16, 185, 129, 0.12);
          }
          .add-time-log-calendar .time-log-entry-accent {
            width: 4px;
            height: 100%;
            min-height: 24px;
            border-radius: 999px;
            background: #3aa98c;
          }
          .add-time-log-calendar .time-log-entry-body {
            min-width: 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
          }
          .add-time-log-calendar .time-log-entry-title {
            color: #1f2937;
            font-size: 12px;
            font-weight: 800;
            line-height: 1.2;
          }
          .add-time-log-calendar .time-log-entry-subtitle {
            color: #6b7280;
            font-size: 11px;
            font-weight: 600;
            line-height: 1.2;
            display: none;
          }
          .add-time-log-calendar .time-log-entry-status {
            margin-top: 0;
            min-height: 24px;
            border-radius: 7px;
            background: #dcf7ef;
            color: #507366;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            gap: 6px;
            padding: 4px 8px;
            font-size: 11px;
            font-weight: 700;
          }
          .add-time-log-calendar .time-log-entry-status i {
            color: #2aa77a;
            font-size: 12px;
          }
          .add-time-log-calendar .rbc-show-more {
            color: #2563eb;
            font-size: 11px;
            font-weight: 700;
            background: transparent;
          }
          .add-time-log-calendar .rbc-calendar {
            height: auto !important;
          }
          .add-time-log-calendar .rbc-month-view {
            height: auto !important;
            flex: none !important;
            border-radius: 12px !important;
            border: 1px solid rgba(226, 232, 240, 0.8) !important;
            box-shadow: none !important;
          }
          .add-time-log-calendar .rbc-header {
            border-bottom: 1px solid rgba(226, 232, 240, 1) !important;
            padding: 12px 6px !important;
            background: linear-gradient(180deg, #f8fbff 0%, #f1f5f9 100%) !important;
            color: #64748b !important;
            font-size: 11px !important;
            font-weight: 800 !important;
          }
          .add-time-log-calendar .rbc-month-row {
            height: 84px !important;
            flex: none !important;
            overflow: visible !important;
          }
          .add-time-log-calendar .rbc-day-bg {
            background: transparent !important;
            cursor: pointer !important;
          }
          .add-time-log-calendar .rbc-day-bg::after,
          .add-time-log-calendar .rbc-day-bg:hover::after,
          .add-time-log-calendar .time-log-day-cell--logged::after,
          .add-time-log-calendar .time-log-day-cell--logged:hover::after,
          .add-time-log-calendar .time-log-day-cell--today::after,
          .add-time-log-calendar .time-log-day-cell--today:hover::after,
          .add-time-log-calendar .time-log-day-cell--blocked::after,
          .add-time-log-calendar .time-log-day-cell--blocked:hover::after,
          .add-time-log-calendar .time-log-date-header::before {
            display: none !important;
          }
          .add-time-log-calendar .rbc-date-cell {
            padding: 5px 6px !important;
            text-align: left !important;
            cursor: pointer !important;
            display: flex !important;
            flex-direction: column !important;
            align-items: stretch !important;
            height: 100% !important;
            overflow: visible !important;
          }
          .add-time-log-calendar .rbc-date-cell > a {
            display: none !important;
          }
          .add-time-log-calendar .time-log-date-header {
            height: 72px !important;
            min-height: 72px !important;
            display: flex !important;
            flex-direction: column !important;
            justify-content: space-between !important;
            align-items: stretch !important;
            width: 100% !important;
            border-radius: 18px !important;
            padding: 8px !important;
            background: #ffffff !important;
            border: 1.5px solid #f1f5f9 !important;
            box-shadow: 0 4px 6px -1px rgba(15, 23, 42, 0.02), 0 2px 4px -1px rgba(15, 23, 42, 0.01) !important;
            transition: transform 220ms cubic-bezier(0.34, 1.56, 0.64, 1), border-color 220ms ease, box-shadow 220ms ease, background-color 220ms ease !important;
            box-sizing: border-box !important;
          }
          .add-time-log-calendar .time-log-date-header--logged {
            border-color: #d1f2e5 !important;
            background: #ffffff !important;
            box-shadow: 0 4px 10px -2px rgba(16, 185, 129, 0.04) !important;
          }
          .add-time-log-calendar .time-log-date-header--today {
            border-color: #bfdbfe !important;
            background: #ffffff !important;
            box-shadow: 0 4px 10px -2px rgba(37, 99, 235, 0.04) !important;
          }
          .add-time-log-calendar .time-log-date-header--blocked {
            background: #f8fafc !important;
            border-color: #e2e8f0 !important;
            border-style: dashed !important;
            opacity: 0.65 !important;
            cursor: not-allowed !important;
            box-shadow: none !important;
          }
          .add-time-log-calendar .time-log-date-header--off-range {
            background: #f8fafc !important;
            border-color: #f1f5f9 !important;
            border-style: dashed !important;
            opacity: 0.4 !important;
            cursor: not-allowed !important;
            box-shadow: none !important;
          }
          .add-time-log-calendar .rbc-date-cell:hover .time-log-date-header {
            transform: translateY(-2px) !important;
            border-color: #cbd5e1 !important;
            box-shadow: 0 12px 22px -8px rgba(15, 23, 42, 0.08), 0 4px 12px -4px rgba(15, 23, 42, 0.03) !important;
          }
          .add-time-log-calendar .rbc-date-cell:hover .time-log-date-header--logged {
            border-color: #10b981 !important;
            box-shadow: 0 14px 26px -8px rgba(16, 185, 129, 0.16), 0 8px 16px -8px rgba(16, 185, 129, 0.08) !important;
          }
          .add-time-log-calendar .rbc-date-cell:hover .time-log-date-header--today {
            border-color: #2563eb !important;
            box-shadow: 0 14px 26px -8px rgba(37, 99, 235, 0.16), 0 8px 16px -8px rgba(37, 99, 235, 0.08) !important;
          }
          .add-time-log-calendar .rbc-date-cell:hover .time-log-date-header--blocked,
          .add-time-log-calendar .rbc-date-cell:hover .time-log-date-header--off-range {
            transform: none !important;
            box-shadow: none !important;
            background: #f1f5f9 !important;
          }
          .add-time-log-calendar .time-log-date-top {
            width: 100% !important;
            display: flex !important;
            justify-content: flex-end !important;
            position: static !important;
            margin-bottom: 6px !important;
          }
          .add-time-log-calendar .time-log-date-number {
            width: auto !important;
            height: auto !important;
            border-radius: 0 !important;
            display: inline-flex !important;
            color: #64748b !important;
            font-size: 18px !important;
            font-weight: 800 !important;
            line-height: 1 !important;
          }
          .add-time-log-calendar .time-log-date-header--logged .time-log-date-number {
            color: #065f46 !important;
          }
          .add-time-log-calendar .time-log-date-header--today .time-log-date-number {
            color: #2563eb !important;
          }
          .add-time-log-calendar .time-log-date-header--blocked .time-log-date-number,
          .add-time-log-calendar .time-log-date-header--off-range .time-log-date-number {
            color: #cbd5e1 !important;
          }
          .add-time-log-calendar .rbc-today {
            background: transparent !important;
          }
          .add-time-log-calendar .rbc-month-row .rbc-row-content {
            z-index: 2 !important;
            overflow: visible !important;
            height: 100% !important;
          }
          .add-time-log-calendar .rbc-month-row .rbc-row-content,
          .add-time-log-calendar .rbc-month-row .rbc-row {
            overflow: visible !important;
            height: 100% !important;
          }
          .add-time-log-calendar .rbc-event,
          .add-time-log-calendar .rbc-event-content {
            display: none !important;
          }
          .add-time-log-calendar .time-log-entry-card {
            width: 100% !important;
            min-height: 30px !important;
            border-radius: 10px !important;
            background: #e6f6f0 !important;
            box-shadow: 0 2px 5px rgba(16, 185, 129, 0.04) !important;
            border: 1px solid rgba(16, 185, 129, 0.2) !important;
            border-left: 4px solid #10b981 !important;
            display: flex !important;
            align-items: center !important;
            gap: 6px !important;
            padding: 3px 8px !important;
            overflow: hidden !important;
            cursor: pointer !important;
            margin-top: auto !important;
            box-sizing: border-box !important;
            transition: border-color 220ms ease, background-color 220ms ease, box-shadow 220ms ease, transform 220ms cubic-bezier(0.34, 1.56, 0.64, 1) !important;
          }
          .add-time-log-calendar .rbc-date-cell:hover .time-log-entry-card {
            border-color: rgba(16, 185, 129, 0.3) !important;
            border-left-color: #059669 !important;
            background: #dcf7ef !important;
            box-shadow: 0 6px 12px rgba(16, 185, 129, 0.08) !important;
            transform: scale(1.02) !important;
          }
          .add-time-log-calendar .time-log-entry-accent {
            display: none !important;
          }
          .add-time-log-calendar .time-log-entry-body {
            flex-grow: 1 !important;
            display: flex !important;
            align-items: center !important;
            min-width: 0 !important;
          }
          .add-time-log-calendar .time-log-entry-status {
            margin-top: 0 !important;
            min-height: auto !important;
            border-radius: 0 !important;
            background: transparent !important;
            color: #065f46 !important;
            border: none !important;
            box-shadow: none !important;
            display: inline-flex !important;
            align-items: center !important;
            justify-content: flex-start !important;
            gap: 5px !important;
            padding: 0 !important;
            font-size: 11px !important;
            font-weight: 800 !important;
            white-space: nowrap !important;
          }
          .add-time-log-calendar .time-log-entry-status i {
            color: #10b981 !important;
            font-size: 10.5px !important;
          }
        `}</style>
        <Modal.Header style={ADD_TIME_LOG_STYLES.modalHeader}>
          <div style={ADD_TIME_LOG_STYLES.headerContent}>
            <Modal.Title as="div" style={ADD_TIME_LOG_STYLES.titleWrap}>
              <span style={ADD_TIME_LOG_STYLES.headerIcon}>
                <i
                  className={isDocumentMode ? "fa fa-upload" : "fa fa-clock-o"}
                  aria-hidden="true"
                ></i>
              </span>
              <div>
                <div style={ADD_TIME_LOG_STYLES.title}>
                  {isDocumentMode ? "Upload Time Sheet" : "Add/Edit Time Log"}
                </div>
                <div style={ADD_TIME_LOG_STYLES.subtitle}>
                  {isDocumentMode
                    ? "Upload approved weekly or monthly time sheet documents for the selected reporting period."
                    : "Select the reporting period and review the calendar to add or update logged hours."}
                </div>
              </div>
            </Modal.Title>
            <div style={ADD_TIME_LOG_STYLES.headerActions}>
              <button
                type="button"
                style={ADD_TIME_LOG_STYLES.closeButton}
                onClick={() => handleShowHide(null)}
                aria-label="Close time log popup"
              >
                <i className="fa fa-times" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body style={ADD_TIME_LOG_STYLES.modalBody}>
          <div style={ADD_TIME_LOG_STYLES.helperCard}>
            <div style={ADD_TIME_LOG_STYLES.helperTitle}>How this works</div>
            <p style={ADD_TIME_LOG_STYLES.helperText}>
              {isDocumentMode
                ? "Upload the required weekly or monthly time sheet files for this time log. The logged calendar hours stay unchanged in this popup."
                : "Pick the year and month, choose whether you want monthly totals or day-by-day entry, then complete the matching section before saving."}
            </p>
          </div>
          <div className="row">
            {isCalendarMode ? (
              <>
                <div className="col-md-12">
                  <div style={ADD_TIME_LOG_STYLES.calendarControlCard}>
                    <div style={ADD_TIME_LOG_STYLES.calendarTopRow}>
                      <div style={ADD_TIME_LOG_STYLES.calendarHeadingWrap}>
                        <div style={ADD_TIME_LOG_STYLES.calendarBadge}>
                          <i className="fa fa-calendar-o" aria-hidden="true"></i>
                        </div>
                        <div>
                          <div style={ADD_TIME_LOG_STYLES.calendarHeadingTitle}>
                            Daily Hours Calendar
                          </div>
                          <div style={ADD_TIME_LOG_STYLES.calendarHeadingText}>
                            Pick a valid day in the selected month to log or update working hours.
                          </div>
                        </div>
                      </div>
                      <div style={ADD_TIME_LOG_STYLES.calendarControlsWrap}>
                        <div style={ADD_TIME_LOG_STYLES.selectWrapper}>
                          <i
                            className="fa fa-calendar"
                            aria-hidden="true"
                            style={ADD_TIME_LOG_STYLES.selectIcon}
                          ></i>
                          <select
                            name="year"
                            id="year"
                            className="form-control"
                            style={ADD_TIME_LOG_STYLES.compactSelect}
                            onChange={handleYearChange}
                            value={selectedYear}
                            aria-label="Year select"
                          >
                            <option value="">Year</option>
                            {years
                              .filter(
                                (x) =>
                                  x.name <= new Date().getFullYear() &&
                                  x.name >= prjStartYear
                              )
                              .map((y) => (
                                <option key={y.name} value={y.name}>
                                  {y.name}
                                </option>
                              ))}
                          </select>
                        </div>
                        <div style={ADD_TIME_LOG_STYLES.selectWrapper}>
                          <i
                            className="fa fa-filter"
                            aria-hidden="true"
                            style={ADD_TIME_LOG_STYLES.selectIcon}
                          ></i>
                          <select
                            name="month"
                            id="month"
                            className="form-control"
                            style={ADD_TIME_LOG_STYLES.compactSelect}
                            onChange={handleMonthChange}
                            value={selectedMonth}
                            aria-label="Month select"
                          >
                            <option value="">Month</option>
                            {filterMonths.map((m) => (
                              <option key={m.id} value={m.id}>
                                {m.name}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div style={ADD_TIME_LOG_STYLES.hoursCardCompact}>
                          <i className="fa fa-clock-o" aria-hidden="true"></i>
                          <span style={ADD_TIME_LOG_STYLES.hoursLabel}>
                            Total Hours
                          </span>
                          <span style={ADD_TIME_LOG_STYLES.hoursValue}>
                            {getTotalHoursByDate()} hrs
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div style={ADD_TIME_LOG_STYLES.calendarShell}>
                    {chkMonthlyHrs !== "monthly" && (
                      <div style={ADD_TIME_LOG_STYLES.calendarWrap} className="add-time-log-calendar">
                        <Calendar
                          selectable
                          localizer={localizer}
                          events={allEvents}
                          date={selectedDate}
                          views={["month"]}
                          onSelectEvent={handleWrkHrShowHide}
                          onSelectSlot={handleWrkHrShowHide}
                          onNavigate={handleDateChanged}
                          eventPropGetter={eventStyleGetter}
                          dayPropGetter={dayPropGetter}
                          components={{
                            event: CalendarEventCard,
                            month: {
                              dateHeader: CalendarDateHeader,
                            },
                          }}
                        />
                      </div>
                    )}
                  </div>
                </div>

                <div className="col-md-12">
                  <div style={ADD_TIME_LOG_STYLES.toggleCard}>
                    <label style={ADD_TIME_LOG_STYLES.switchLabel} htmlFor="chkMonthlyHrs">
                      <input
                        name="chkMonthlyHrs"
                        id="chkMonthlyHrs"
                        type="checkbox"
                        style={ADD_TIME_LOG_STYLES.switchInput}
                        onChange={handleChkMonthly}
                        value="monHrs"
                        checked={chkMonthlyHrs === "monthly"}
                      />
                      <span>Monthly Hour(s) - Non-Billable Staff</span>
                    </label>
                    {chkMonthlyHrs === "monthly" && (
                      <div className="row mt-3">
                        <div className="col-md-6 form-group">
                          <label htmlFor="monthlyHrs" style={ADD_TIME_LOG_STYLES.fieldLabel}>
                            Enter Monthly Hour(s)
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            style={ADD_TIME_LOG_STYLES.inputShell}
                            id="monthlyHrs"
                            name="monthlyHrs"
                            value={monthlyHrs}
                            placeholder="Enter Monthly Hours"
                            onChange={({ currentTarget }) =>
                              setMonthlyHrs(currentTarget.value)
                            }
                          />
                        </div>
                        <div className="col-md-6 form-group">
                          <label htmlFor="monthlyDays" style={ADD_TIME_LOG_STYLES.fieldLabel}>
                            Enter Total Day(s)
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            style={ADD_TIME_LOG_STYLES.inputShell}
                            id="monthlyDays"
                            name="monthlyDays"
                            value={monthlyDays}
                            placeholder="Enter Total Days"
                            onChange={({ currentTarget }) =>
                              setMonthlyDays(currentTarget.value)
                            }
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="col-md-12">
                  <div style={ADD_TIME_LOG_STYLES.sectionCard}>
                    <div style={ADD_TIME_LOG_STYLES.sectionTitle}>Reporting Period</div>
                    <div style={ADD_TIME_LOG_STYLES.sectionSubtitle}>
                      Review the selected reporting period before uploading supporting files.
                    </div>
                    <div style={ADD_TIME_LOG_STYLES.statsRow}>
                      <div style={ADD_TIME_LOG_STYLES.statCard}>
                        <div style={ADD_TIME_LOG_STYLES.statLabel}>Selected Year</div>
                        <div style={ADD_TIME_LOG_STYLES.statValue}>{selectedYear || "--"}</div>
                      </div>
                      <div style={ADD_TIME_LOG_STYLES.statCard}>
                        <div style={ADD_TIME_LOG_STYLES.statLabel}>Selected Month</div>
                        <div style={ADD_TIME_LOG_STYLES.statValue}>
                          {selectedMonth ? getMonthName(parseInt(selectedMonth)) : "--"}
                        </div>
                      </div>
                      <div style={ADD_TIME_LOG_STYLES.statCard}>
                        <div style={ADD_TIME_LOG_STYLES.statLabel}>Total Hours</div>
                        <div style={ADD_TIME_LOG_STYLES.statValue}>
                          {getTotalHoursByDate()}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-12">
                  <div style={ADD_TIME_LOG_STYLES.divider}></div>
                </div>

                <div className="col-md-12 form-group">
                  <div style={ADD_TIME_LOG_STYLES.sectionCard}>
                    <div style={ADD_TIME_LOG_STYLES.sectionTitle}>Time Sheet Upload</div>
                    <div style={ADD_TIME_LOG_STYLES.sectionSubtitle}>
                      Upload weekly or monthly time sheet documents for this row.
                    </div>
                    <div style={ADD_TIME_LOG_STYLES.radioWrap}>
                      <div className="custom-control custom-radio">
                        <input
                          name="docType"
                          className="custom-control-input"
                          id="uploadWeeklyTimeSheet"
                          type="radio"
                          onChange={() => setDocType("weekly")}
                          value="weekly"
                          checked={docType === "weekly"}
                        />
                        <label
                          className="custom-control-label mr-2"
                          htmlFor="uploadWeeklyTimeSheet"
                        >
                          Upload weekly time sheets
                        </label>
                      </div>
                      <div className="custom-control custom-radio">
                        <input
                          name="docType"
                          className="custom-control-input"
                          id="uploadMonthlyTimeSheet"
                          type="radio"
                          onChange={() => setDocType("monthly")}
                          value="monthly"
                          checked={docType === "monthly"}
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="uploadMonthlyTimeSheet"
                        >
                          Upload monthly time sheet
                        </label>
                      </div>
                    </div>
                    <div className="row">
                      {docType === "weekly" ? (
                        <div className="col-md-12 mt-2">
                          <div style={ADD_TIME_LOG_STYLES.uploadGrid}>
                            {[1, 2, 3, 4, 5].map((week) => (
                              <div key={week} style={ADD_TIME_LOG_STYLES.uploadCard}>
                                <div style={ADD_TIME_LOG_STYLES.uploadTitle}>
                                  Week {week}
                                </div>
                                <div style={ADD_TIME_LOG_STYLES.uploadHint}>
                                  Upload the approved weekly time sheet for this reporting week.
                                </div>
                                <input
                                  type="file"
                                  id={`week${week}`}
                                  name={`week${week}`}
                                  className="form-control"
                                  style={ADD_TIME_LOG_STYLES.inputShell}
                                  onChange={onFileChange}
                                />
                              </div>
                            ))}
                          </div>
                        </div>
                      ) : (
                        <>
                          <div className="col-md-6 mt-2">
                            <label htmlFor="timeSheet" style={ADD_TIME_LOG_STYLES.fieldLabel}>
                              Upload monthly approved time sheet
                            </label>
                            <input
                              type="file"
                              name="timeSheet"
                              id="timeSheet"
                              className="form-control"
                              style={ADD_TIME_LOG_STYLES.inputShell}
                              onChange={onFileChange}
                            />
                          </div>
                          <div className="col-md-6 mt-2">
                            <label htmlFor="signDoc" style={ADD_TIME_LOG_STYLES.fieldLabel}>
                              Upload monthly supporting document (If Required)
                            </label>
                            <input
                              type="file"
                              name="signDoc"
                              id="signDoc"
                              className="form-control"
                              style={ADD_TIME_LOG_STYLES.inputShell}
                              onChange={onFileChange}
                            />
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </>
            )}

            <div className="col-md-12">
              <div style={ADD_TIME_LOG_STYLES.noteBanner}>
                {isDocumentMode
                  ? "Please note: Documents that are password-protected or restricted from printing should not be uploaded."
                  : "Please note: Save your logged hours here. Time sheet documents are now uploaded separately from the upload action."}
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer style={ADD_TIME_LOG_STYLES.modalFooter}>
          {viewType !== "invoice" && (
            <div style={ADD_TIME_LOG_STYLES.footerActions}>
              {isCalendarMode && (
                <button
                  className="btn btn-sm"
                  style={ADD_TIME_LOG_STYLES.subtleButton}
                  onClick={handleReset}
                >
                  <i className="fa fa-refresh" aria-hidden="true"></i> Reset
                </button>
              )}
              <button
                className="btn btn-sm"
                style={ADD_TIME_LOG_STYLES.primaryButton}
                disabled={saveBtnProccess}
                onClick={() => doSubmit("save")}
              >
                {saveBtnProccess ? (
                  <i className="fa fa-spinner fa-spin"></i>
                ) : (
                  <i
                    className={isDocumentMode ? "fa fa-upload" : "fa fa-check"}
                    aria-hidden="true"
                  ></i>
                )}{" "}
                {isDocumentMode ? "Upload Time Sheet" : "Save Hours"}
              </button>
            </div>
          )}
        </Modal.Footer>
      </Modal>
      {wrkHrShowHide && (
        <AddWorkingHrs
          handleShowHide={handleWrkHrShowHide}
          showHide={wrkHrShowHide}
          selectedObj={dtObj}
          handleSelect={handleSelect}
          handleeEditSelect={handleeEditSelect}
          allEvents={allEvents}
        ></AddWorkingHrs>
      )}
    </>
  );
};

export default AddNewTimeLog;
